import type { ComputedRef, InjectionKey } from 'vue';
import type { SelectionCardMode } from '../SelectionCard/SelectionCard.types';
import type { SelectionCardValue } from './SelectionCardGroup.types';

export type SelectionCardRegistration = {
  value: () => SelectionCardValue | undefined;
  disabled: () => boolean;
  element: () => HTMLElement | null;
};

export type SelectionCardGroupContext = {
  mode: ComputedRef<SelectionCardMode>;
  disabled: ComputedRef<boolean>;
  tabStopId: ComputedRef<string | null>;
  isSelected: (value: SelectionCardValue) => boolean;
  select: (value: SelectionCardValue) => void;
  register: (id: string, registration: SelectionCardRegistration) => void;
  unregister: (id: string) => void;
};

export const SELECTION_CARD_GROUP_CONTEXT_KEY: InjectionKey<SelectionCardGroupContext> =
  Symbol('selection-card-group-context');
